// ─── Portal Layout — sin sidebar del ERP ─────────────────────

import React from 'react';
import { Outlet } from 'react-router-dom';

interface PortalLayoutProps {
  titulo:         string;
  colorPrimario?: string;
}

const PortalLayout: React.FC<PortalLayoutProps> = ({
  titulo,
  colorPrimario = '#2563EB',
}) => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#F9FAFB' }}>
      {/* Header */}
      <header
        className="w-full flex items-center px-6 py-4 shadow-sm"
        style={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid #E5E7EB' }}
      >
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs font-bold"
            style={{ backgroundColor: colorPrimario }}
          >
            RM
          </div>
          <span className="text-sm font-semibold" style={{ color: '#111827' }}>
            RM Desarrollos — {titulo}
          </span>
        </div>
      </header>

      {/* Contenido */}
      <main className="flex-1 w-full">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="w-full py-4 text-center">
        <p className="text-xs" style={{ color: '#9CA3AF' }}>
          © {new Date().getFullYear()} RM Desarrollos — ERP SaaS
        </p>
      </footer>
    </div>
  );
};

export default PortalLayout;
